import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/lensor.webp';
import screenshot_target from '../../../images/letterfunnel/robinvanruitenbeek.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Robin van Ruitenbeek"
      firstname="Robin"
      companyname="Lensor"
      competition="UVeye en ProovStation"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/robinvanruitenbeek.js